import { CarrierPickupStatus } from "@redotech/redo-model/carrier-pickups/carrier-pickup";
import { CarrierSchema } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import { RateProvider } from "@redotech/redo-model/outbound-labels/outbound-labels";
import { WeightSchema } from "@redotech/redo-model/outbound-labels/util";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import { OpensearchPaginationCursorSchema } from "@redotech/redo-views-common/table";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const PickupAddressResponseSchema = z.object({
  companyName: z.string().nullish(),
  contactName: z.string().nullish(),
  addressLine: z.string().nullish(),
  city: z.string().nullish(),
  stateProvince: z.string().nullish(),
  postalCode: z.string().nullish(),
  countryCode: z.string().nullish(),
  phoneNumber: z.string().nullish(),
});

const PickupSchema_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  name: z.string().nullish(),
  pickupRequestNumber: z.string(),
  carrier: CarrierSchema,
  provider: createEnum(RateProvider),
  pickupDate: z.string(),
  readyTime: z.object({ hour: z.number(), minute: z.number() }).nullish(),
  closeTime: z.object({ hour: z.number(), minute: z.number() }).nullish(),
  pickupAddress: PickupAddressResponseSchema.nullish(),
  packageCount: z.number().nullish(),
  totalWeight: WeightSchema.nullish(),
  specialInstructions: z.string().nullish(),
  referenceNumber: z.string().nullish(),
  status: createEnum(CarrierPickupStatus).nullish(),
  rate: z.string().nullish(),
  carrierResponse: z.record(z.string(), z.unknown()).nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const PickupSchema: z.ZodType<CarrierPickupResponse> = PickupSchema_;
export interface CarrierPickupResponse extends z.infer<typeof PickupSchema_> {}

const TableSortSchema = z
  .object({ key: z.string(), direction: z.enum(["asc", "desc"]) })
  .nullish();

export const searchPickups = {
  name: "searchPickups" as const,
  input: z.object({
    teamId: zExt.objectId(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema),
    search: z.string().nullish(),
    sort: TableSortSchema,
    pageSize: z.number(),
    pageNumber: z.number(),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    pickups: z.array(PickupSchema),
    opensearchCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};

export const searchPickupsCount = {
  name: "searchPickupsCount" as const,
  input: z.object({
    teamId: zExt.objectId(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema),
    search: z.string().nullish(),
    sort: TableSortSchema,
  }),
  output: z.object({ total: z.number() }),
};
